const convertToBinary = (value) => (value === true ? 1 : 0);
export default convertToBinary;
